import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators';
import { getWorkspace, getWorkspaceWithCredentials } from '@/store/clients/api';
import { Client } from 'altru-types';
import { getWorkspacePayload, getWorkspaceWithCredentialsPayload } from '@/store/clients/types';

@Module({ namespaced: true })
export default class ClientsModule extends VuexModule {
  workspace: Client | null = null;
  termsAcceptedAt: string | null = null;

  get workspaceInfo(): Client | null {
    return this.workspace;
  }

  get userInformationNeeded(): boolean {
    return (
      !!this.workspace?.feature_keys?.includes('unauthenticated_users') &&
      (!!this.workspace?.feature_hash?.recording_form_fields?.optional?.length ||
        !!this.workspace?.feature_hash?.recording_form_fields?.required?.length)
    );
  }

  @Mutation
  setWorkspaceInfo(value: Client): void {
    this.workspace = {
      ...this.workspace,
      ...value,
    };
  }

  @Action
  async getWorkspace({ clientId, payload }: getWorkspacePayload): Promise<Client> {
    try {
      const workspace = await getWorkspace(clientId, payload);
      this.context.commit('setWorkspaceInfo', workspace);
      return workspace;
    } catch (e) {
      return e.response;
    }
  }

  @Action
  async getWorkspaceWithCredentials({
    clientId,
    authHeaders,
    region = 'us',
  }: getWorkspaceWithCredentialsPayload): Promise<Client> {
    try {
      const workspace = await getWorkspaceWithCredentials(clientId, authHeaders, region);
      this.context.commit('setWorkspaceInfo', workspace);
      return workspace;
    } catch (e) {
      return e.response;
    }
  }

  get workspaceTermsAcceptedAt(): string | null {
    return this.termsAcceptedAt;
  }

  @Mutation
  setWorkspaceTermsAcceptedAt(value: string | null): void {
    this.termsAcceptedAt = value;
  }

  @Action
  toggleWorkspaceTermsAccepted(value: string | null): void {
    try {
      this.context.commit('setWorkspaceTermsAcceptedAt', value);
    } catch (e) {
      return e.response;
    }
  }
}
